// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"77862597","455":"09e69bdd","977":"960cf263"}[chunkId] + ".chunk.js";
};